import { AspectRatio } from '@chakra-ui/react';
import Image from 'next/image';
import { FC } from 'react';

interface ILectureCardImageProps {
  src?: string;
  alt?: string;
}

export const LectureCardImage: FC<ILectureCardImageProps> = ({ src, alt }) => (
  // the tint sits on the ratio box: the filled image covers it exactly, so this
  // is only visible through transparent artwork
  <AspectRatio maxW="full" ratio={1.69} bg="gray.50">
    <Image src={src} alt={alt} fill sizes="300px" />
  </AspectRatio>
);
